import { type FC } from 'react';
import {
  EyeSlash
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconEyeSlashProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconEyeSlash: FC<UiIconEyeSlashProps> = (props) => {
  return (
    <UiIcon
      IconComponent={EyeSlash}
      {...props}
    />
  );
};
